import { createContext, useContext } from "react";

export interface ChatContextValue {
  /** Whether the chat drawer is open. */
  isOpen: boolean;
  /** Open the chat drawer. */
  open: () => void;
  /** Close the chat drawer. */
  close: () => void;
}

export const ChatContext = createContext<ChatContextValue | null>(null);

/** Access the chat drawer's open state. Must be used within a ChatProvider. */
export function useChat(): ChatContextValue {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error("useChat must be used within a ChatProvider");
  }
  return context;
}
